module.exports = __webpack_public_path__ + "img/3-1-allegiant-stadium-buyout.9f10b30f.jpg";